
export const utils = {
    ordinalSuffixOf: function (i) {
        let j = i % 10,
            k = i % 100;
        if (j === 1 && k !== 11) {
            return i + "st";
        }
        if (j === 2 && k !== 12) {
            return i + "nd";
        }
        if (j === 3 && k !== 13) {
            return i + "rd";
        }
        return i + "th";
    },
    getParticipants: function(store, roundNumber){
        let participants = [];
        store.state.teams.forEach((team) => {
            participants.push({id: team.id, seed: roundNumber<3?team.initialSeed:team.seed});
        });
        participants = participants.sort(( a, b) => a.seed - b.seed);
        return participants;
    },

    getResults: function(store){
        const results=[];
        store.state.rounds.forEach((roundResults) => {
            roundResults.races.forEach((race) => {
                    // we assume starboard is slightly favoured so treat it like a home game
                    results.push({
                        round: roundResults.number,
                        home: {
                            id: race.team2.teamId,
                            points: race.winner === race.team2.teamId ? 1 : 0
                        },
                        away: {
                            id: race.team1.teamId,
                            points: race.winner === race.team1.teamId ? 1 : 0
                        },
                    });

                   /* results.push({
                        round: roundResults.number,
                        home: {
                            id: race.team2.teamId,
                            points: race.result?21 - this.sumArray(race.result[race.team2.teamId]):0//race.winner === race.team2.teamId ? 1 : 0
                        },
                        away: {
                            id: race.team1.teamId,
                            points: race.result?21 - this.sumArray(race.result[race.team1.teamId]):0
                        },
                    });*/
                 /*results.push({
                     round: roundResults.number,
                     home: {
                         id: race.team2.teamId,
                         points: race.result?(30 - this.sumArray(race.result[race.team2.teamId]))/30:0//race.winner === race.team2.teamId ? 1 : 0
                     },
                     away: {
                         id: race.team1.teamId,
                         points: race.result?(30 - this.sumArray(race.result[race.team1.teamId]))/30:0
                     },
                 });*/
            });
        });
        return results;
    },
    sumArray: function(array){
        let sum=0;
        array.forEach((item)=>sum+=item);
        return sum;
    }

}